import { render } from "./Packages.vue?vue&type=template&id=13d0d7c2&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"

import "./Packages.vue?vue&type=style&index=0&id=13d0d7c2&scoped=true&lang=scss"
import "./Packages.vue?vue&type=style&index=1&id=13d0d7c2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d0d7c2"]])

export default __exports__